import Information from './Information'
import Monitoring from './Monitoring'
import Setting from './Setting'
import Statement from './Statement'

const VNIS = {
    Information,
    Setting,
    Monitoring,
    Statement,
}

export default VNIS
